(() => {
  const initCarousel = (root) => {
    const track = root.querySelector("[data-lfdl-carousel-track]");
    if (!track) return;

    const prev = root.querySelector("[data-lfdl-carousel-prev]");
    const next = root.querySelector("[data-lfdl-carousel-next]");
    const auto = root.dataset.autoScroll === "true";
    const interval = parseInt(root.dataset.autoInterval || "3500", 10);
    let timer = null;

    const getStep = () => {
      const card = track.querySelector(".lfdl-blog-carousel__card");
      if (!card) return track.clientWidth;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || "0");
      return card.getBoundingClientRect().width + gap;
    };

    const scrollByStep = (dir) => {
      track.scrollBy({ left: dir * getStep(), behavior: "smooth" });
    };

    if (prev) {
      prev.addEventListener("click", () => scrollByStep(-1));
    }
    if (next) {
      next.addEventListener("click", () => scrollByStep(1));
    }

    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const start = () => {
      if (!auto) return;
      stop();
      timer = setInterval(() => {
        const max = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= max - 4) {
          track.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          scrollByStep(1);
        }
      }, interval);
    };

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    root.addEventListener("touchstart", stop, { passive: true });
    root.addEventListener("touchend", start, { passive: true });

    start();
  };

  const init = () => {
    document.querySelectorAll("[data-lfdl-blog-carousel]").forEach(initCarousel);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
